export default {
  suppliers: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  billsToPay: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  departments: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  categories: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  fornecedores: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  billsToReceive: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  servico: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  observationsBillsToReceive: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  pjs: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  faturamentoAnexos: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  solicitations: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  // Quantidade de solicitações pendentes (banner de Contas a pagar). Slice
  // próprio: `solicitations` é da tela de Solicitações (mês + force) e
  // compartilhar o cache fazia o banner ver a lista errada.
  solicitationsPendingCount: {
      loading: false,
      lastUpdate: null,
      data: 0,
  },
  filiais: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  // {{NEXT}}
  billsStatus: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
}
